import {
  getList,
  getLevelList,
  setGameSort,
  getLevelDetail,
  saveLevel,
  addLevel,
  delLevel,
  delGame,
  updateGame,
  createGame,
  UpdateGamePos,
  getReleaseList,
  getReleaseInfo,
  releaseGame2,
  updateReleaseGame,
  getTipList,
  setTip,
  updateTip,
  UpdateGameMap,
  DeleteTip,
  getBonus,
  updateBonus,
  getJunkList,
  restoreGame,
  completeDelete,
  applyCreate,
  ApplyList,
  auditApply,
  getFeedbackList,
  updateFeedback,
  updateFeedbackLink,
  backgroundStart2,
  backgroundEnd2,
  getStory,
  getRoles,
  saveRole,
  updRole,
  delRole,
  editGameReview,
} from "@/api/game";
import { ActionContext } from "vuex";
import { AxiosError } from "axios";
import { ElMessage } from "element-plus";
import { webUserStatus } from "@/api/user";

import user from "@/store/modules/user";
import store from "@/store";

const getDefaultState = (): gameState => {
  return {
    total: 0,
    size: 0,
    games: [],
    levels: [],
    story: {},
  };
};

const state: gameState = getDefaultState();

const mutations = {
  RESET_STATE(state: gameState) {
    console.log(123);
    Object.assign(state, getDefaultState());
  },
  SET_TOTAL(state: gameState, total: number) {
    state.total = total;
  },
  SET_SIZE(state: gameState, size: number) {
    state.size = size;
  },
  SET_GAMES(state: gameState, games: Array<any>) {
    state.games = games;
  },
  SET_LEVELS(state: gameState, levels: Array<any>) {
    state.levels = levels;
  },
  UPDATE_POS(state: gameState, { gameId, value1, value2 }) {
    state.games = state.games.map((item) => {
      if (item.id === gameId) {
        item.longitude = value1;
        item.latitude = value2;
      }
      return item;
    });
  },

  UPDATE_MAP(state: gameState, { gameId, value1, value2 }) {
    state.games = state.games.map((item) => {
      if (item.id === gameId) {
        item.mapSelect = value1;
        item.customizeMap = value2;
      }
      return item;
    });
  },

  UPDATE_MAP2(state: gameState, { gameId, value1 }) {
    state.games = state.games.map((item) => {
      if (item.id === gameId) {
        item.mapSelect = value1;
      }
      return item;
    });
  },

  UPDATE_Link(state: gameState, { gameId, value1 }) {
    state.games = state.games.map((item) => {
      if (item.id === gameId) {
        item.feedbackLink = value1;
      }
      return item;
    });
  },

  UPDATE_STORY(state: gameState, data: any) {
    state.story = data;
  },
};

const actions = {
  getGameList(
    { commit }: ActionContext<State, any>,
    { pageNum, pageSize, userId, status }: GameListParams
  ) {
    return new Promise((resolve, reject) => {
      getList({ pageNum, pageSize, userId, status })
        .then((response: ApiResponse) => {
          const { data } = response;

          if (data) {
            const { total, size, records } = data;

            const aa = records.map((record) => {
              record.tips = JSON.parse(record.tips);
              return record;
            });

            commit("SET_TOTAL", total);
            commit("SET_SIZE", size);
            commit("SET_GAMES", aa);
          } else {
            commit("SET_TOTAL", 0);
            commit("SET_SIZE", 0);
            commit("SET_GAMES", []);
          }

          resolve(data);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  },

  getJunkGameList(
    { commit }: ActionContext<State, any>,
    { pageNum, pageSize, userId, status }: GameListParams
  ) {
    return new Promise((resolve, reject) => {
      getJunkList({ pageNum, pageSize, userId, status })
        .then((response: ApiResponse) => {
          const { data } = response;

          resolve(data);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  },

  getGameList2(
    { commit }: ActionContext<State, any>,
    { pageNum, pageSize, status }: GameListParams
  ) {
    return new Promise((resolve, reject) => {
      getReleaseList({ pageNum, pageSize, status })
        .then((response: ApiResponse) => {
          const { data } = response;

          resolve(data);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  },

  getFeedbackList(
    { commit }: ActionContext<State, any>,
    { pageNum, pageSize, gameId }: feedback
  ) {
    return new Promise((resolve, reject) => {
      getFeedbackList({ pageNum, pageSize, gameId })
        .then((response: ApiResponse) => {
          const { data } = response;

          resolve(data);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  },

  getApply(
    { commit }: ActionContext<State, any>,
    { pageNum, pageSize, status }: GameListParams
  ) {
    return new Promise((resolve, reject) => {
      ApplyList({ pageNum, pageSize, status })
        .then((response: ApiResponse) => {
          const { data } = response;

          resolve(data);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  },

  auditApply(
    { commit }: ActionContext<State, any>,
    { id, code }: { id: string; code: number }
  ) {
    return new Promise((resolve, reject) => {
      auditApply({ id: id, code: code })
        .then((response: ApiResponse) => {
          const { data } = response;

          resolve(data);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  },

  getGameLevelList(
    { commit }: ActionContext<State, any>,
    { gameLevelId }: { gameLevelId: string }
  ) {
    return new Promise((resolve, reject) => {
      getLevelList({ gameLevelId })
        .then((response: ApiResponse) => {
          const { data } = response;

          const updatedRes = data.map((item, index) => ({
            levelId: item.id,
            id: index + 1,
            name: item.levelTitle,
          }));

          commit("SET_LEVELS", updatedRes);

          resolve(data);
        })
        .catch((error: any) => {
          commit("SET_LEVELS", []);
          reject(error);
        });
    });
  },

  getGameLevelList2(
    { commit }: ActionContext<State, any>,
    { gameLevelId }: { gameLevelId: string }
  ) {
    return new Promise((resolve, reject) => {
      getLevelList({ gameLevelId })
        .then((response: ApiResponse) => {
          const { data } = response;

          resolve(data);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  },

  getTipList(
    { commit }: ActionContext<State, any>,
    { tips }: { tips: string }
  ) {
    return new Promise((resolve, reject) => {
      getTipList({ tips })
        .then((response: ApiResponse) => {
          const { data } = response;

          resolve(data);
        })
        .catch((error: any) => {
          commit("SET_LEVELS", []);
          reject(error);
        });
    });
  },

  getTipList2(
    { commit }: ActionContext<State, any>,
    { tips }: { tips: string }
  ) {
    return new Promise((resolve, reject) => {
      getTipList({ tips })
        .then((response: ApiResponse) => {
          const { data } = response;

          resolve(data);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  },

  addTip(
    { commit }: ActionContext<State, any>,
    { belongId }: { belongId: string }
  ) {
    return new Promise((resolve, reject) => {
      setTip({ belongId })
        .then((response: ApiResponse) => {
          const { data } = response;

          resolve(data);
        })
        .catch((error: any) => {
          commit("SET_LEVELS", []);
          reject(error);
        });
    });
  },

  setGameSort(
    { commit }: ActionContext<State, any>,
    { gameLevelId, sortLevel }: { gameLevelId: string; sortLevel: string }
  ) {
    return new Promise((resolve, reject) => {
      setGameSort({ gameLevelId, sortLevel })
        .then((response: ApiResponse) => {
          const { data } = response;

          resolve(data);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  },

  getLevelDetail(
    { commit }: ActionContext<State, any>,
    { levelId }: { levelId: string }
  ) {
    return new Promise((resolve, reject) => {
      getLevelDetail({ levelId })
        .then((response: ApiResponse) => {
          const { data } = response;

          resolve(data);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  },

  editGameReview(
    { commit }: ActionContext<State, any>,
    {
      gameLevelId,
      reviewTitle,
      reviewContent,
      reviewLink,
      reviewImg,
    }: {
      gameLevelId: string;
      reviewTitle: string;
      reviewContent: string;
      reviewLink: string;
      reviewImg: string;
    }
  ) {
    return new Promise((resolve, reject) => {
      editGameReview({
        gameLevelId,
        reviewTitle,
        reviewContent,
        reviewLink,
        reviewImg,
      })
        .then((response: ApiResponse) => {
          const { data } = response;

          resolve(data);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  },

  saveLevel(
    { commit }: ActionContext<State, any>,
    { levelBean }: { levelBean: any }
  ) {
    return new Promise((resolve, reject) => {
      saveLevel(levelBean)
        .then((response: ApiResponse) => {
          const { data } = response;
          if (response.code == 200) {
            ElMessage.success({
              message: "修改成功",
            });
          }

          resolve(data);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  },
  delLevel(
    { commit }: ActionContext<State, never>,
    {
      ids,
      gameLevelId,
      gameId,
    }: { ids: Array<never>; gameLevelId: string; gameId: string }
  ) {
    return new Promise((resolve, reject) => {
      delLevel({ ids: ids }, { gameLevelId: gameLevelId, gameId: gameId })
        .then((response: ApiResponse) => {
          const { data } = response;
          if (response.code == 200) {
            ElMessage.success({
              message: "删除关卡",
            });
          }

          resolve(data);
        })
        .catch((error: never) => {
          reject(error);
        });
    });
  },
  add2Level(
    { commit }: ActionContext<State, any>,
    {
      levelTitle,
      gameLevelId,
      gameId,
    }: { levelTitle: string; gameLevelId: string; gameId: string }
  ) {
    return new Promise((resolve, reject) => {
      addLevel({
        levelTitle: levelTitle,
        gameLevelId: gameLevelId,
        gameId: gameId,
      })
        .then((response: ApiResponse) => {
          const { data } = response;
          if (response.code == 200) {
            ElMessage.success({
              message: "添加关卡",
            });
          }

          resolve(data);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  },

  delGame(
    { commit }: ActionContext<State, any>,
    { ids }: { ids: Array<string> }
  ) {
    return new Promise((resolve, reject) => {
      delGame({ ids: ids })
        .then((response: ApiResponse) => {
          const { data } = response;
          if (response.code == 200) {
            ElMessage.success({
              message: "删除成功",
            });
          }

          resolve(data);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  },

  completeGame({ commit }: ActionContext<State, any>, { id }: { id: string }) {
    return new Promise((resolve, reject) => {
      completeDelete({ id: id })
        .then((response: ApiResponse) => {
          const { data } = response;
          if (response.code == 200) {
            ElMessage.success({
              message: "删除成功",
            });
          }

          resolve(data);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  },

  delTip(
    { commit }: ActionContext<State, any>,
    { levelId, tipId }: { levelId: string; tipId: string }
  ) {
    return new Promise((resolve, reject) => {
      DeleteTip({ levelId: levelId, tipId: tipId })
        .then((response: ApiResponse) => {
          const { data } = response;

          if (data == 1) {
            ElMessage.success({
              message: "删除成功",
            });
          }

          resolve(data);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  },

  createGame({ commit }: ActionContext<State, any>) {
    return new Promise((resolve, reject) => {
      createGame()
        .then((response: ApiResponse) => {
          const { data } = response;

          resolve(data);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  },
  updateGame(
    { commit }: ActionContext<State, any>,
    { gameBean }: { gameBean: any }
  ) {
    return new Promise((resolve, reject) => {
      updateGame(gameBean)
        .then((response: ApiResponse) => {
          const { data } = response;

          if (data == 1) {
            ElMessage.success({
              message: "修改成功",
            });
          }

          resolve(data);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  },

  getStory(
    { commit }: ActionContext<State, any>,
    { gameId }: { gameId: string }
  ) {
    return new Promise((resolve, reject) => {
      getStory({ gameId: gameId })
        .then((response: ApiResponse) => {
          const { data } = response;
          commit("UPDATE_STORY", data);
          resolve(data);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  },

  getStory2(
    { commit }: ActionContext<State, any>,
    { gameId }: { gameId: string }
  ) {
    return new Promise((resolve, reject) => {
      getStory({ gameId: gameId })
        .then((response: ApiResponse) => {
          const { data } = response;
          commit("UPDATE_STORY", data);
          resolve(data);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  },

  updateTip(
    { commit }: ActionContext<State, any>,
    { levelId, ids, tips }: { levelId: string; ids: string; tips: any }
  ) {
    return new Promise((resolve, reject) => {
      updateTip({ levelId: levelId, ids: ids }, tips)
        .then((response: ApiResponse) => {
          const { data } = response;

          resolve(data);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  },

  updateRelease(
    { commit }: ActionContext<State, any>,
    {
      releaseId,
      status,
      remark,
    }: { releaseId: string; status: number; remark: string }
  ) {
    return new Promise((resolve, reject) => {
      updateReleaseGame({
        releaseId: releaseId,
        status: status,
        remark: remark,
      })
        .then((response: ApiResponse) => {
          const { data } = response;

          resolve(data);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  },

  UpdateFeedback(
    { commit }: ActionContext<State, any>,
    {
      id,
      email,
      content,
      question,
    }: { id: string; email: number; content: string; question: string }
  ) {
    return new Promise((resolve, reject) => {
      updateFeedback({
        id: id,
        email: email,
        content: content,
        question: question,
      })
        .then((response: ApiResponse) => {
          const { data } = response;

          resolve(data);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  },

  UpdateFeedbackLink(
    { commit }: ActionContext<State, any>,
    { id, link }: { id: string; link: string }
  ) {
    return new Promise((resolve, reject) => {
      updateFeedbackLink({
        id: id,
        link: link,
      })
        .then((response: ApiResponse) => {
          const { data } = response;

          if (data == 1) {
            commit("UPDATE_Link", {
              gameId: id,
              value1: link,
            });
            ElMessage.success({
              message: "修改成功",
            });
          }

          resolve(data);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  },

  getRelease(
    { commit }: ActionContext<State, any>,
    { releaseId }: { releaseId: string }
  ) {
    return new Promise((resolve, reject) => {
      getReleaseInfo({ releaseId: releaseId })
        .then((response: ApiResponse) => {
          const { data } = response;

          resolve(data);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  },

  getBonus(
    { commit }: ActionContext<State, any>,
    { gameId }: { gameId: string }
  ) {
    return new Promise((resolve, reject) => {
      getBonus({ gameId: gameId })
        .then((response: ApiResponse) => {
          const { data } = response;

          resolve(data);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  },

  getRoles(
    { commit }: ActionContext<State, any>,
    { gameId }: { gameId: string }
  ) {
    return new Promise((resolve, reject) => {
      getRoles({ gameId: gameId })
        .then((response: ApiResponse) => {
          const { data } = response;

          resolve(data);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  },

  saveRole(
    { commit }: ActionContext<State, any>,
    {
      gameId,
      roleDesc,
      roleImg,
      roleName,
      roleAge,
      roleSex,
      roleProfession,
      roleSkill,
    }: {
      gameId: string;
      roleDesc: string;
      roleImg: string;
      roleName: string;
      roleAge: string;
      roleSex: string;
      roleProfession: string;
      roleSkill: string;
    }
  ) {
    return new Promise((resolve, reject) => {
      saveRole({
        gameId: gameId,
        roleDesc: roleDesc,
        roleImg: roleImg,
        roleName: roleName,
        roleAge: roleAge,
        roleSex: roleSex,
        roleProfession: roleProfession,
        roleSkill: roleSkill,
      })
        .then((response: ApiResponse) => {
          const { data } = response;

          resolve(data);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  },

  updRole(
    { commit }: ActionContext<State, any>,
    {
      gameId,
      roleDesc,
      roleImg,
      roleName,
      roleId,
    }: {
      gameId: string;
      roleDesc: string;
      roleImg: string;
      roleName: string;
      roleId: string;
    }
  ) {
    return new Promise((resolve, reject) => {
      updRole({
        roleId: roleId,
        gameId: gameId,
        roleDesc: roleDesc,
        roleImg: roleImg,
        roleName: roleName,
      })
        .then((response: ApiResponse) => {
          const { data } = response;

          resolve(data);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  },

  delRole(
    { commit }: ActionContext<State, never>,
    { ids }: { ids: Array<never> }
  ) {
    return new Promise((resolve, reject) => {
      delRole({ ids: ids })
        .then((response: ApiResponse) => {
          const { data } = response;

          resolve(data);
        })
        .catch((error: never) => {
          reject(error);
        });
    });
  },

  restoreGame({ commit }: ActionContext<State, any>, { id }: { id: string }) {
    return new Promise((resolve, reject) => {
      restoreGame({ id: id })
        .then((response: ApiResponse) => {
          const { data } = response;
          if (data == 1) {
            ElMessage.success({
              message: "还原成功",
            });
          }
          resolve(data);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  },

  updateGameStart(
    { commit }: ActionContext<State, any>,
    {
      id,
      title,
      content,
      img,
      mediaType,
      videoLink,
    }: {
      id: string;
      title: string;
      content: string;
      img: string;
      mediaType: string;
      videoLink: string;
    }
  ) {
    return new Promise((resolve, reject) => {
      backgroundStart2({
        id: id,
        title: title,
        content: content,
        img: img,
        mediaType: mediaType,
        videoLink: videoLink,
      })
        .then((response: ApiResponse) => {
          const { data } = response;
          commit("UPDATE_STORY", data);
          resolve(data);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  },

  updateGameEnd(
    { commit }: ActionContext<State, any>,
    {
      id,
      title,
      content,
      img,
    }: { id: string; title: string; content: string; img: string }
  ) {
    return new Promise((resolve, reject) => {
      backgroundEnd2({ id: id, title: title, content: content, img: img })
        .then((response: ApiResponse) => {
          const { data } = response;
          commit("UPDATE_STORY", data);
          resolve(data);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  },

  updateBonus(
    { commit }: ActionContext<State, any>,
    { integralBean }: { integralBean: any }
  ) {
    return new Promise((resolve, reject) => {
      updateBonus(integralBean)
        .then((response: ApiResponse) => {
          const { data } = response;

          if (data == 1) {
            ElMessage.success({
              message: "修改成功",
            });
          }

          resolve(data);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  },

  applyCreate({ commit }: ActionContext<State, any>) {
    return new Promise((resolve, reject) => {
      applyCreate({
        id: store.state.user.Id,
        name: store.state.user.name,
        email: store.state.user.email,
        code: 0,
      })
        .then((response: ApiResponse) => {
          const { data } = response;

          if (data == 1) {
            ElMessage.success({
              message: "申请成功",
            });
          }

          resolve(data);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  },

  releaseGame2(
    { commit }: ActionContext<State, any>,
    { gameId, publicStatue }: { gameId: string; publicStatue: number }
  ) {
    return new Promise((resolve, reject) => {
      releaseGame2({ gameId: gameId, publicStatue: publicStatue })
        .then((response: ApiResponse) => {
          const { data } = response;

          resolve(data);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  },

  UpdateUserStatus(
    { commit, state }: ActionContext<State, any>,
    userInfo: { status: number; userId: string }
  ) {
    return new Promise((resolve, reject) => {
      webUserStatus(userInfo)
        .then((response: ApiResponse) => {
          const { data } = response;

          resolve(data);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  },

  UpdateGamePos(
    { commit }: ActionContext<State, any>,
    {
      gameId,
      value1,
      value2,
    }: { gameId: string; value1: number; value2: number }
  ) {
    return new Promise((resolve, reject) => {
      UpdateGamePos({ gameId: gameId, value1: value1, value2: value2 })
        .then((response: ApiResponse) => {
          const { data } = response;

          if (data == 1) {
            ElMessage.success({
              message: "更改位置",
            });

            commit("UPDATE_POS", {
              gameId: gameId,
              value1: value1,
              value2: value2,
            });
          }

          resolve(data);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  },

  UpdateGameMap(
    { commit }: ActionContext<State, any>,
    {
      gameId,
      mapSelect,
      customizeMap,
    }: { gameId: string; mapSelect: string; customizeMap: string }
  ) {
    return new Promise((resolve, reject) => {
      UpdateGameMap({
        gameId: gameId,
        mapSelect: mapSelect,
        customizeMap: customizeMap,
      })
        .then((response: ApiResponse) => {
          const { data } = response;

          if (data == 1) {
            ElMessage.success({
              message: "保存成功",
            });

            commit("UPDATE_MAP", {
              gameId: gameId,
              value1: mapSelect,
              value2: customizeMap,
            });
          } else if (data == 2) {
            ElMessage.success({
              message: "保存成功",
            });

            commit("UPDATE_MAP2", {
              gameId: gameId,
              value1: mapSelect,
            });
          }

          resolve(data);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
